import React from 'react';
import {
  Row,
  Col,
  Divider,
  Input,
  Typography,
  Table,
  Space,
  Skeleton,
  Result
} from 'antd';
// import {
//   PlusOutlined
// } from '@ant-design/icons';

import { useQuery } from '@tanstack/react-query';
import DeletePopupButton from './components/DeletePopupButton';
import AddFormModal from './components/AddFormModal';


const columns = ({employees}) => [
  {
    title: 'บัญชีผู้ใช้งาน',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: 'ประเภทบัญชี',
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: 'ชื่อ',
    dataIndex: 'employee',
    key: 'fname',
    render: (text, record) => text?.fname
  },

  {
    title: 'เบอร์โทร',
    dataIndex: 'employee',
    key: 'phone',
    render: (text, record) => text?.phone
  },
  {
    title: 'ตำแหน่ง',
    dataIndex: 'employee',
    key: 'position',
    render: (text, record) => text?.position
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <DeletePopupButton data={record} />
      </Space>
    ),
  }
]

function List() {

  const { isError, isLoading, data, error } = useQuery({
    queryKey: ['/api/user/'],
  })
  const employees = useQuery({ queryKey: ['/api/employee/'] })


  const onSearch = e => {
    console.log('onSearch :', e);
  }


  if (isLoading || employees.isLoading) {
    return <Skeleton active />
  }

  if (isError || employees.isError) {
    return <Result status="error" title={error.message || employees.error.message} />
  };


  // console.log('data =>', data);
  // console.log(' employees.data =>',  employees.data);
  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการบัญชีผู้ใช้งาน
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
            <AddFormModal employees={employees.data}/>
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input.Search
                placeholder="ค้นหาตามรายชื่อ หรือเบอร์โทร"
                onSearch={onSearch}
                enterButton
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns({employees: employees.data })}
                dataSource={data}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List